var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnToOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.96 2.5C16.349 2.50006 19.9199 6.0709 19.9199 10.46C19.9198 13.7731 17.8622 16.7382 14.7783 17.9053L11.9512 22.5L9.24414 17.9434C7.75898 17.4053 6.48121 16.4484 5.53906 15.165C4.53216 13.7934 4.00004 12.1664 4 10.46C4 6.07086 7.5709 2.5 11.96 2.5ZM10.9814 10.7236L9.3418 9.07812L7.91602 10.5088L10.9814 13.585L16 8.54883L14.5742 7.11816L10.9814 10.7236Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnToOwner);
export default __webpack_public_path__ + "static/media/return-to-owner.98ad60f6c8d34a3d71cee405a834fce7.svg";
export { ForwardRef as ReactComponent };